// Module
var code = " <div data-bind=\"ifnot: showEditPage\"> <inspection-locations-list-component params=\"showEditPage: showEditPage\"></inspection-locations-list-component> </div> <div data-bind=\"if: showEditPage\"> <inspection-locations-edit-component params=\"locationId: locationId, showEditPage: showEditPage\"></inspection-locations-edit-component> </div>";
// Exports
export default code;